import React from 'react';
import PropTypes from 'prop-types';
import { BrowserUtils } from '../../../utils';

export const ExtraBottomPadding = ({ children }) => {
    const divRef = React.useRef(null);
    const isIOSSafari = BrowserUtils.isIOSSafari();
    const initialScreenHeight = BrowserUtils.screenHeight();
    const toggleExtraPadding = () => {
        if (divRef && divRef.current) {
            divRef.current.classList.toggle('prisma-vertical-safari-extra-padding-bottom', BrowserUtils.screenHeight() > initialScreenHeight);
        }
    };
    React.useEffect(() =>{
        if (isIOSSafari) {
            window.addEventListener('scroll', toggleExtraPadding);
        }
        return () => {
            if (isIOSSafari) {
                window.removeEventListener('scroll', toggleExtraPadding);
            }
        };
    }, []);

    return (
        <div ref={divRef}>
            {children}
        </div>
    );
};

ExtraBottomPadding.propTypes = {
    children: PropTypes.node.isRequired,
};
